import React from "react";
import { useTranslation } from "react-i18next";

const SignupStepper = ({ currentStep }) => {
  const { t } = useTranslation("signup");

  const STEPS = [
    { id: 1, label: t("account_info") },
    { id: 2, label: t("company_details") },
    { id: 3, label: t("visual_identity") },
  ];

  if (currentStep >= 4) return null;

  return (
    <div className="signup-stepper">
      {STEPS.map((step) => (
        <div
          key={step.id}
          className={`step-item ${currentStep === step.id ? "active" : ""} ${currentStep > step.id ? "completed" : ""}`}
        >
          <div className="step-counter">{step.id}</div>
          <div className="step-label">{step.label}</div>
        </div>
      ))}
    </div>
  );
};

export default SignupStepper;
